import { useTranslations } from '@utils/i18n-to-migrate/useTranslations'
import type { TenantId } from '@utils/tenant-utils'
import { Check } from 'lucide-react'
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import { useTenant } from '@/contexts/TenantContext'

export const TenantMenuItems: React.FC = () => {
  const { t } = useTranslations()
  const { currentTenant, availableTenants, switchTenant, isLoading } = useTenant()

  const handleTenantSwitch = (tenantId: string) => {
    void switchTenant(tenantId as TenantId)
  }

  return (
    <DropdownMenuGroup className="pb-2">
      {availableTenants.map((tenant, i) => {
        const isCurrent = tenant.id === currentTenant.id

        return (
          <>
            <DropdownMenuItem
              key={tenant.id}
              onClick={() => {
                if (!isCurrent) {
                  handleTenantSwitch(tenant.id)
                }
              }}
              disabled={isLoading}
              className="flex items-center gap-3 py-1 px-1 cursor-pointer hover:bg-muted"
            >
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors ${
                  isCurrent
                    ? 'bg-viken-shoots-100 border border-viken-shoots-400'
                    : 'bg-input border border-input'
                }`}
              >
                {isCurrent && <Check size={16} className="text-viken-shoots-900" />}
              </div>
              <div className="flex flex-col">
                <span className="font-medium text-xs leading-normal">{tenant.displayName}</span>
                {isCurrent && (
                  <span className="text-xs text-muted-foreground">
                    {t('tenant-menu-items.currentTenant')}
                  </span>
                )}
              </div>
            </DropdownMenuItem>
            {i < availableTenants.length - 1 && <DropdownMenuSeparator />}
          </>
        )
      })}
    </DropdownMenuGroup>
  )
}
